// extracted by mini-css-extract-plugin
var _1 = "qegf5UY2rsEBRnFtDGgi";
var _2 = "omOuMXO0emSVPr692b_x";
var _3 = "dSqcUFtGo1ViX4XVnl22";
var _4 = "hrMOH1Y5wrhI5SN7d6vw";
var _5 = "vAAia78Epdu7ZyfIYQsu";
var _6 = "G8em6bNeGbVsiS_1HyD_";
export { _1 as "employeeList", _2 as "header", _3 as "noResults", _4 as "resultText", _5 as "searchWrapper", _6 as "seeMore" }
